module.exports = __webpack_public_path__ + "img/pro_five_3.1eb461e1.jpg";